// extracted by mini-css-extract-plugin
export default {"gateway-api-key-modal":"Tqg5uyvGfU","gatewayApiKeyModal":"Tqg5uyvGfU"};